import { Box } from "@mui/material";

const ErrorText = (props: any) => {
  return <Box className="errorHandleMessage">{props.children}</Box>;
};

export default ErrorText;
